import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { CandidateRouteInfo, ICustomPageContext, IRouterContext, RouterContextConfig } from '../types'
import { name } from '../symbols'
import { getContextByRouteInfo } from '../urlUtils'

export const RouterContext = withDependencies(
	[named(EditorFeatureConfigSymbol, name)],
	(routerContextConfig: RouterContextConfig): IRouterContext | ICustomPageContext => {
		const state = {
			context: 0,
		}
		return {
			getRouteInfoContext(routeInfo: CandidateRouteInfo) {
				const { viewMode, previewEditorMode } = routerContextConfig
				const context = getContextByRouteInfo(routeInfo)
				const type = routeInfo.type.toLowerCase()
				const result = `${context}_${previewEditorMode}_${viewMode}_${type}`
				return state.context ? `${result}_${state.context}` : result
			},
			generateNewContext() {
				state.context = (state.context + 1) % 100
			},
		}
	}
)
